import { Necesitas, Cuesta, Hablar, Ser, QueEs } from '../scenes/Know/articles';

export const know = [
  {
    title: '¿Qué es un asesor financiero?',
    icon: 'user',
    text:
      '¿Qué actividades realizan los asesores financieros y cómo ayudan a sus clientes?' +
      'Respondemos a todas tus dudas',
    path: '/asesores/saber/que-es-un-asesor-financiero',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: QueEs
  },
  {
    title: '¿Necesitas un asesor?',
    icon: 'help',
    text: 'Quizás te preguntes si necesitas un asesor financiero para el control y gestión de tus finanzas. Te contamos todas las claves de porque si merece la pena.',
    path: '/asesores/saber/necesitas-un-asesor',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Necesitas
  },
  {
    title: '¿Cuánto cobra un asesor financiero?',
    icon: 'dollar',
    text:
      '¿Necesitas saber cuánto cobra un asesor financiero por consulta? En este post te respondemos cuánto suele cobrar un asesor financiero en España.',
    path: '/asesores/saber/cuanto-cuesta',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Cuesta
  },
  {
    title: '¿Cómo tiene que ser?',
    icon: 'user',
    text: 'Descubre las cualidades clave que debe tener un asesor financiero profesional y alineado con tus objetivos. Aprende a identificarlo para tu situación financiera.',
    path: '/asesores/saber/como-tiene-que-ser',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Ser
  },
  {
    title: '¿De qué hablar?',
    icon: 'chat',
    text: 'Hablar con tu asesor financiero va más allá de invertir. Descubre los temas clave que debes tratar para tomar mejores decisiones y alcanzar tus objetivos.',
    path: '/asesores/saber/de-que-hablar',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Hablar
  }
];
